




























































import { Faq } from '@/types/common'
import Vue from 'vue'
import FAQItem from '@/common/components/faq/FAQItem.vue'
import FAQImagePreview from '@/common/components/faq/FAQImagePreview.vue'

const MAX_DISPLAY_COLUMN = 2

export default Vue.extend({
  components: { FAQItem, FAQImagePreview },
  props: {
    productId: {
      type: [String, Number],
      default: ''
    },
    faqs: {
      type: Array as () => Faq[],
      default: () => []
    }
  },
  data(): {
    showPreviewImage: boolean
    previewImgSrc: string
  } {
    return {
      showPreviewImage: false,
      previewImgSrc: ''
    }
  },
  computed: {
    MAX_DISPLAY_COLUMN(): number {
      return MAX_DISPLAY_COLUMN
    },
    faqColumns(): Faq[][] {
      const faqColumns: Faq[][] = Array.from({ length: MAX_DISPLAY_COLUMN }, () => [])
      this.faqs.forEach((faq, index) => {
        const column = index % MAX_DISPLAY_COLUMN
        faqColumns[column].push(faq)
      })
      return faqColumns
    }
  },
  methods: {
    onImageClick(value: string) {
      this.showPreviewImage = true
      this.previewImgSrc = value
    }
  }
})
